import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	date: {
		textTransform: "uppercase"
	}
})

export default useStyles
